import { app } from '@/main.js'
import ApiService from '@/services/ApiService.js'
import store from '@/store/store'
export const namespaced = true

let patientStr = {
  de: 'patient',
  en: 'patient',
  fr: 'patient',
  it: 'paziente',
  nl: 'patiënt',
  ca: 'patient'
}
let patientsStr = {
  de: 'patienten',
  en: 'patients',
  fr: 'patients',
  it: 'pazienti',
  nl: 'patiënten',
  ca: 'patients'
}
let padStr = {
  de: 'IKM',
  en: 'brief',
  fr: 'couche',
  it: 'pannolino',
  nl: 'luier',
  ca: 'brief'
}
let padsStr = {
  de: 'IKM',
  en: 'briefs',
  fr: 'couches',
  it: 'pannolini',
  nl: 'luiers',
  ca: 'briefs'
}

export const state = {
  currentLocale: sessionStorage.getItem('selected_language'),
  patient:
    patientStr[sessionStorage.getItem('selected_language')] || patientStr['en'],
  patients:
    patientsStr[sessionStorage.getItem('selected_language')] ||
    patientsStr['en'],
  pad: padStr[sessionStorage.getItem('selected_language')] || padStr['en'],
  pads: padsStr[sessionStorage.getItem('selected_language')] || padsStr['en']
}

export const mutations = {
  SET_LOCALE: function(state, value) {
    app.$i18n.locale = value
    state.currentLocale = value
    sessionStorage.setItem('selected_language', value)
  },
  INITIALIZE_LOCALE: function(state) {
    state.currentLocale = 'en'
    sessionStorage.setItem('selected_language', 'en')
  },
  SET_PATIENT(state, value) {
    state.patient = value
  },
  SET_PAD(state, value) {
    state.pad = value
  },
  SET_PATIENTS(state, value) {
    state.patients = value
  },
  SET_PADS(state, value) {
    state.pads = value
  }
}

export const actions = {
  saveLocale({ commit }, value) {
    commit('SET_LOCALE', value)
  },
  initializeLocale({ commit }) {
    if (state.currentLocale == null) commit('INITIALIZE_LOCALE')
  },
  getCustomTerms({ commit }) {
    ApiService.GetOrganisationSettings(
      store.getters[`user/selecteOrganisationId`]
    ).then(res => {
      if (res.data.success) {
        let response = res.data.data
        if (response && response.Patient && response.Patient.length > 0) {
          response.Patient.forEach(item => {
            patientStr[item.Language] = item.PatientValue
            patientsStr[item.Language] = item.PluralPatientValue
          })
        }
        if (response && response.Pad && response.Pad.length > 0) {
          response.Pad.forEach(item => {
            padStr[item.Language] = item.PadValue
            padsStr[item.Language] = item.PluralPadValue
          })
        }
      }
      commit('SET_PATIENT', patientStr[state.currentLocale])
      commit('SET_PAD', padStr[state.currentLocale])
      commit('SET_PATIENTS', patientsStr[state.currentLocale])
      commit('SET_PADS', padsStr[state.currentLocale])
    })
  }
}

export const getters = {
  GetCurrentLocale: state => {
    return state.currentLocale
  }
}
